import { FC } from 'react';

import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';
import { selectProductInCart } from '@telialt/utils/src/eshopSelectors';
import { isEmpty } from '@telialt/utils/src/helpers';

import {
    InsuranceFeatureContainerGrid,
    InsuranceIconContainerFlex,
    InsuranceVasIcon,
    InsuranceVasIconTitle,
    InsuranceVasSubtitle,
    InsuranceVasTitle,
    InsuranceVasWrapper,
} from './InsuranceVAS.styles';

export const InsuranceVAS: FC = () => {
    const { cart } = useCartQuery();
    const insuranceVAS = selectProductInCart(cart)?.insuranceVas;

    if (!insuranceVAS) {
        return null;
    }

    return (
        <InsuranceVasWrapper data-test={ESHOP_TEST_ID.INSURANCE_VAS}>
            <InsuranceVasTitle>
                <strong>{insuranceVAS.title}</strong>
            </InsuranceVasTitle>
            <InsuranceVasSubtitle>{insuranceVAS.description}</InsuranceVasSubtitle>
            {!isEmpty(insuranceVAS.vasProducts) && (
                <InsuranceFeatureContainerGrid>
                    {insuranceVAS.vasProducts.map((product, i) => (
                        <InsuranceIconContainerFlex key={i}>
                            <InsuranceVasIcon name={product.iconType} />
                            <InsuranceVasIconTitle>{product.title}</InsuranceVasIconTitle>
                        </InsuranceIconContainerFlex>
                    ))}
                </InsuranceFeatureContainerGrid>
            )}
        </InsuranceVasWrapper>
    );
};
